import { gql } from '@apollo/client';

export const GET_CURRENT_USER = gql`
  query GetUser {
    me {
      displayName
      givenName
      surname
      jobTitle
      businessPhones
      mobilePhone
      officeLocation
      userPrincipalName
      images {
        large
        medium
        small
      }
      id
      mail
      preferredLanguage
    }
  }
`;
